import { render } from "./Header.vue?vue&type=template&id=2a2f666d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2a2f666d&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2f666d"]])

export default __exports__